let tracker

const getTracker = () => {
  if (window?.user.role === 'admin' || ['1', '2', '3', '4', '5', '6', '7'].includes(window?.user?.id)) {
    return undefined
  }
  if (tracker) return tracker

  tracker = window?.Matomo?.getTracker()

  return tracker
}

const track = (callback) => {
  const tracker = getTracker()

  if (!tracker) console.log('Matomo tracker not available')
  if (tracker) {
    callback(tracker)
  }
}

export const trackSiteSearch = (keyword, category, resultCount) => {
  track((tracker) => {
    tracker.trackSiteSearch(keyword, category, resultCount)
  })
}

export const trackPageView = (page, lastPage, role) => {
  track((tracker) => {
    if (lastPage) {
      const { origin } = window.location
      tracker.setReferrerUrl(origin + '/app' + lastPage)
    }

    tracker.setCustomDimension(1, role);
    tracker.setCustomUrl(window.location.href)
    tracker.setDocumentTitle(document.title)

    tracker.deleteCustomVariables('page')
    tracker.trackPageView()
  })
}

export const trackOpenPanelEvent = (panel) => {
  track(() => {
    tracker.trackEvent('panel', 'open', 'panel_' + panel)
  })
}

export const trackClosePanelEvent = (panel) => {
  track(() => {
    tracker.trackEvent('panel', 'close', 'panel_' + panel)
  })
}

export const trackRegisterStudent = (action) => {
  track(() => {
    tracker.trackEvent('student', action, 'register-student')
  })
}
